import React from 'react'
import { FaSearch } from 'react-icons/fa'

export const liveBetSortOptions = [
  { label: 'Betted time: newest first', value: 'time-desc' },
  { label: 'Betted time: oldest first', value: 'time-asc' },
  { label: 'Betted amount: high to low', value: 'amount-desc' },
  { label: 'Betted amount: low to high', value: 'amount-asc' },
  { label: 'Betted type: A to Z', value: 'type-asc' },
  { label: 'Betted type: Z to A', value: 'type-desc' },
]

const controlClasses =
  'h-10 w-full rounded-lg border border-customAccentBlue/20 bg-white px-3 text-sm text-customPrimaryText outline-none transition focus:border-customAccentBlue focus:ring-2 focus:ring-customAccentBlue/30 dark:border-customSurfaceMuted dark:bg-customSurfaceMuted dark:text-customHeading'

const LiveBettingFilters = ({
  statusOptions,
  statusFilter,
  onStatusChange,
  selectedDate,
  onDateChange,
  searchQuery,
  onSearchChange,
  sortBy,
  onSortChange,
}) => {
  return (
    <section className="rounded-xl border border-customAccentBlue/20 bg-white p-4 shadow-lg shadow-customAccentBlue/10 dark:border-customSurface dark:bg-customSurface">
      {/* <header className="mb-4">
        <h2 className="text-lg font-semibold text-customPrimaryText dark:text-customHeading">
          Outstanding Report
        </h2>
        <p className="text-sm text-customSecondaryText dark:text-customMuted">
          Filter and order live vouchers before they settle.
        </p>
      </header> */}

      <div className="grid gap-3 md:grid-cols-2 xl:grid-cols-[minmax(240px,1.4fr)_minmax(165px,0.8fr)_minmax(150px,0.75fr)_minmax(240px,1fr)]">
        <label className="min-w-0 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
          Search voucher or username
          <span className="relative mt-1 block">
            <FaSearch
              aria-hidden="true"
              className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-customSecondaryText"
            />
            <input
              type="search"
              value={searchQuery}
              onChange={(event) => onSearchChange(event.target.value)}
              placeholder="Voucher no. or username"
              className={`${controlClasses} pl-9`}
            />
          </span>
        </label>

        {/* <label className="min-w-0 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
          Betted date
          <input
            type="date"
            value={selectedDate}
            onChange={(event) => onDateChange(event.target.value)}
            className={`${controlClasses} mt-1`}
          />
        </label> */}

        <label className="min-w-0 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
          Ticket status
          <select
            value={statusFilter.value}
            onChange={(event) => {
              const selected = statusOptions.find((option) => option.value === event.target.value)
              if (selected) onStatusChange(selected)
            }}
            className={`${controlClasses} mt-1`}
          >
            {statusOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>

        <label className="min-w-0 text-xs font-semibold text-customSecondaryText dark:text-customMuted">
          Sort order
          <select
            value={sortBy}
            onChange={(event) => onSortChange(event.target.value)}
            className={`${controlClasses} mt-1`}
          >
            {liveBetSortOptions.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </select>
        </label>
      </div>
    </section>
  )
}

export default LiveBettingFilters
